import { inject, Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { BrowserPlatformService } from '../../shared/services/browser-platform.service';

const KEEP_EXPANDED_AFTER_NAVIGATION_STORAGE_KEY = 'cmsKeepSidebarExpandedAfterNavigation';

@Injectable({
  providedIn: 'root',
})
export class SidebarService {
  private readonly browser = inject(BrowserPlatformService);

  private isExpandedSubject = new BehaviorSubject<boolean>(this.readKeepExpandedAfterNavigation());
  private isMobileOpenSubject = new BehaviorSubject<boolean>(false);
  private keepExpandedAfterNavigationSubject = new BehaviorSubject<boolean>(
    this.readKeepExpandedAfterNavigation(),
  );

  isExpanded$ = this.isExpandedSubject.asObservable();
  isMobileOpen$ = this.isMobileOpenSubject.asObservable();
  keepExpandedAfterNavigation$ = this.keepExpandedAfterNavigationSubject.asObservable();

  get keepExpandedAfterNavigation(): boolean {
    return this.keepExpandedAfterNavigationSubject.value;
  }

  setExpanded(val: boolean) {
    this.isExpandedSubject.next(val);
  }

  toggleExpanded() {
    this.isExpandedSubject.next(!this.isExpandedSubject.value);
  }

  setMobileOpen(val: boolean) {
    this.isMobileOpenSubject.next(val);
  }

  toggleMobileOpen() {
    this.isMobileOpenSubject.next(!this.isMobileOpenSubject.value);
  }

  setKeepExpandedAfterNavigation(val: boolean) {
    this.keepExpandedAfterNavigationSubject.next(val);
    this.writeKeepExpandedAfterNavigation(val);
  }

  toggleKeepExpandedAfterNavigation() {
    this.setKeepExpandedAfterNavigation(!this.keepExpandedAfterNavigationSubject.value);
  }

  private readKeepExpandedAfterNavigation(): boolean {
    return this.browser.getLocalStorageItem(KEEP_EXPANDED_AFTER_NAVIGATION_STORAGE_KEY) === '1';
  }

  private writeKeepExpandedAfterNavigation(val: boolean): void {
    if (val) {
      this.browser.setLocalStorageItem(KEEP_EXPANDED_AFTER_NAVIGATION_STORAGE_KEY, '1');
    } else {
      this.browser.removeLocalStorageItem(KEEP_EXPANDED_AFTER_NAVIGATION_STORAGE_KEY);
    }
  }
}
